import PropTypes from 'prop-types'
import InputBlock from '../input-block'

const GroupForm = ({ onGroupDescriptionChange, onMaxPointsChange, onMaxCountChange, formik }) => {
  return (
    <div className="pl-3">
      <div className="w-[384px]">
        <InputBlock
          label="Group description*"
          className="mt-1"
          id="ruleGroup"
          placeholder="Group description*"
          autoComplete="given-name"
          formik={formik}
          onChange={e => onGroupDescriptionChange(e.target.value)}
        />
        <p className="text-sm text-[--gray-600] font-normal mt-1 mb-8">
          A short description. Limited to 50 characters.
        </p>
      </div>
      <div className="ml-0 flex flex-row gap-8">
        <div className="w-[384px]">
          <InputBlock
            label="Maximum points"
            className="mt-1"
            id="maxPoints"
            placeholder="Maximum points"
            autoComplete="given-name"
            onChange={e => onMaxPointsChange(e.target.value)}
            formik={formik}
          />
          <p className="text-sm text-[--gray-600] font-normal mt-1 mb-8">
            Maximum number of points that can be earned from the rules within this group. Ex: if set to 1000, the
            combined rules in the group can earn up to 1000 points.
          </p>
        </div>
        <div className="w-[384px]">
          <InputBlock
            label="Maximum count"
            className="mt-1"
            id="maxCount"
            placeholder="Maximum count"
            autoComplete="given-name"
            onChange={e => onMaxCountChange(e.target.value)}
            formik={formik}
          />
          <p className="text-sm text-[--gray-600] font-normal mt-1">
            Maximum number of times rewards can be earned through the rules within this group. This limits the reward
            triggers for the entire group.
          </p>
        </div>
      </div>
    </div>
  )
}
export default GroupForm

GroupForm.propTypes = {
  onGroupDescriptionChange: PropTypes.func.isRequired,
  onMaxPointsChange: PropTypes.func.isRequired,
  onMaxCountChange: PropTypes.func.isRequired,
  formik: PropTypes.object.isRequired,
}
